<script setup>
import { ref, toRefs, onBeforeMount } from 'vue'
import mySwal from '@/src/javascripts/plugins/mySwal.js'
import { SendOutlined } from '@ant-design/icons-vue'
import BaseTextInput from '@/src/vueComponent/BaseTextInput.vue'
import BaseDatePicker from '@/src/vueComponent/BaseDatePicker.vue'
import BaseFileUpload from '@/src/vueComponent/BaseFileUpload.vue'
import BackButton from '@/src/vueComponent/BackButton.vue'

const props = defineProps({
  token: {
    type: String
  },
  publicDataInfo: {
    type: Object,
    default: () => {
      return {
        id: null,
        title: '',
        description: '',
        approval_date: '',
        file_infos: []
      }
    }
  }
})
const { token, publicDataInfo } = toRefs(props)
const editPublicDataInfo = ref(publicDataInfo.value)

onBeforeMount(() => {
  editPublicDataInfo.value = {
    ...editPublicDataInfo.value,
    file_infos: editPublicDataInfo.value.file_infos || [],
    remove_file_ids: []
  }
})

const handleDeleteProjectFile = (deletedFileId) => {
  editPublicDataInfo.value.remove_file_ids.push(deletedFileId)
}

const handleDeletePreviewFile = (fileIndex) => {
  editPublicDataInfo.value = {
    ...editPublicDataInfo.value,
    file_infos: [
      ...editPublicDataInfo.value.file_infos.slice(0, fileIndex),
      ...editPublicDataInfo.value.file_infos.slice(fileIndex + 1)
    ]
  }
}

const submitForm = () => {
  const formData = new FormData()

  for (const [key, value] of Object.entries(editPublicDataInfo.value)) {
    if (!Array.isArray(value)) {
      formData.append(key, value)
    }
  }

  editPublicDataInfo.value.file_infos.forEach((file, index) => {
    if (file instanceof File) {
      formData.append(`upload_files[${index}]`, file)
    }
  })

  if (Array.isArray(editPublicDataInfo.value.remove_file_ids)) {
    editPublicDataInfo.value.remove_file_ids.forEach((id, index) => {
      formData.append(`remove_file_ids[${index}]`, id)
    })
  }

  $.ajax({
    url: editPublicDataInfo.value.id
      ? `/public_data/${editPublicDataInfo.value.id}`
      : '/public_data',
    type: editPublicDataInfo.value.id ? 'PATCH' : 'POST',
    headers: { 'X-CSRF-Token': token.value },
    authenticity_token: true,
    processData: false,
    contentType: false,
    enctype: 'multipart/form-data',
    data: formData,
    success: async (response) => {
      if (response.state === 0) {
        window.location.replace('/public_data')
      }
    },
    error: async (error) => {
      console.log('error', error)
      if (error.responseJSON.state === -1) {
        await mySwal.error({
          title: error.responseJSON.message.join('<br />'),
          timer: 3000
        })

        if (error.responseJSON.redirect_to) {
          window.location.replace(error.responseJSON.redirect_to)
        }
      }
    }
  })
}
</script>
<template>
  <form @submit.prevent="submitForm" class="leave-need-confirm">
    <div class="mb-3">
      <div class="mb-6 grid grid-cols-4 gap-4 md:grid-cols-2">
        <BaseTextInput
          :label="'標題'"
          :name="'title'"
          v-model="editPublicDataInfo.title"
          :maxlength="20"
          required
        />
        <BaseDatePicker
          :label="'日期'"
          :name="'approval_date'"
          v-model="editPublicDataInfo.approval_date"
          required
        />
        <BaseTextInput
          :label="'描述'"
          :name="'description'"
          v-model="editPublicDataInfo.description"
          class="col-span-2"
          :maxlength="100"
        />
        <BaseFileUpload
          :label="'附檔'"
          :projectFileList="editPublicDataInfo.file_infos"
          :readonly="false"
          :maxFileSize="30"
          class="col-span-2"
          @uploadFile="editPublicDataInfo.file_infos = $event"
          @deleteProjectFile="handleDeleteProjectFile"
          @deletePreviewFile="handleDeletePreviewFile"
        />
      </div>
    </div>
    <div class="flex items-center justify-end gap-3 py-3">
      <BackButton :hasForm="true" :returnPath="'/public_data'" />
      <button type="submit" class="btn btn-success text-xl text-white">
        <SendOutlined />
        送出
      </button>
    </div>
  </form>
</template>
